/**
 * @description: 项目执行人数统计
 * @Date: 2023-01-18 18:04:01
 */

import { OptionData, Data } from './type';
import { nextTick, computed } from 'vue';
export const selfAdaption = async (TaskRef, ContentRef, scale) => {
  await nextTick(() => {
    const parent = TaskRef.value.parentNode as HTMLDivElement;
    const parentWidth = parent.offsetWidth;
    const parentHeight = parent.offsetHeight;
    const contentWidth = ContentRef.value.offsetWidth;
    const constHeight = ContentRef.value.offsetHeight;
    scale.value = Math.min(
      1,
      parentWidth / contentWidth,
      parentHeight / constHeight == 0 ? 1 : parentHeight / constHeight
    );
  });
};

//数据处理
export const dataProcessing = (datas: OptionData, comp: object) => {
  return computed(() => {
    const tips = ['当前报告总题目', '总参与人数（人或者机构）', '分析维度'];
    const res: Array<Data> = [];
    for (let i = 0; i < 3; i++) {
      res[i] = {} as Data;
      res[i]['comp'] = comp[i];
      res[i]['tipsText'] = datas?.tips?.[i] || tips[i];
      if (i == 0) {
        res[i]['data'] = datas['topicSum'] + '题';
      }
      if (i == 1) {
        res[i]['data'] = datas['userSum'] + '个';
        res[i]['isShowUserSum'] = datas['isShowUserSum'];
      }
      if (i == 2) {
        res[i]['data'] = datas['analysisDimen'];
      }
    }
    return res;
  });
};
